import React, { FC } from "react";
import classNames from "classnames";
import { SbGatsbyStory, useStoryblokState } from "gatsby-source-storyblok";
import { INews, IPosts } from "./models";
import { Hero } from "./components/hero/Hero";
import { Body } from "./components/body/Body";
import { Footer } from "./components/footer/Footer";

type Props = {
  content: SbGatsbyStory;
  related: SbGatsbyStory;
};

export const BlogPost: FC<Props> = ({ content, related }) => {
  const parsedContent = (useStoryblokState(content) as unknown as INews)
    .content;
  const relatedEntries = (
    useStoryblokState(related) as unknown as IPosts
  ).edges.map((post) => post.node);

  return (
    <div
      className={classNames(
        "mx-auto mb-40 max-w-container-wide px-5",
        "md:px-0",
      )}
    >
      <div className={classNames("pt-40", "lg:pt-60")}>
        <Hero
          title={parsedContent.title}
          image={parsedContent.image}
          youtubeId={parsedContent.youtube_id}
        />
        <Body
          title={parsedContent.title}
          date={parsedContent.date}
          categoryId={parsedContent.categoryName}
          body={parsedContent.body}
        />
      </div>
      <Footer
        articleTitle={parsedContent.title}
        pressReleaseVideos={parsedContent.press_release_videos.map((p) => ({
          title: p.title,
          excerpt: p.body,
          youtubeId: p.youtube_id,
        }))}
        pressReleaseFile={parsedContent.press_release_file.filename}
        relatedPosts={relatedEntries}
      />
    </div>
  );
};
